// src/services/trustedxService.js
const BACKEND_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080';
// Ajusta la URL base de tu backend

/**
 * Llama a /txDocumentSign/getDocumentInfo?processId=xxx&token=xxx
 * para obtener el estado (finished, canceled, etc.) y otros detalles del proceso de firma.
 */
export async function getDocumentProcessInfo(processId, token) {
    const url = `${BACKEND_BASE_URL}/signature/txDocumentSign/getDocumentInfo?processId=${processId}&token=${token}`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            // error HTTP
            const text = await response.text();
            throw new Error(`Error getDocumentProcessInfo: ${text}`);
        }
        return await response.json(); // Devuelve un objeto JSON con { allOk: true/false, result: {...}, ... }
    } catch (error) {
        throw error;
    }
}

/**
 * Llama a /txDocumentSign/getDocument?signer_process_id=xxx&status=xxx&token=xxx
 * para obtener el PDF firmado en base64, junto con el nombre del archivo.
 */
export async function getSignedDocument(processId, status, token) {
    const docId = sessionStorage.getItem('docId');
    const url = `${BACKEND_BASE_URL}/signature/txDocumentSign/getDocument?signer_process_id=${processId}&status=${status}&token=${token}&docId=${docId}`;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            // error HTTP
            const text = await response.text();
            throw new Error(`Error getSignedDocument: ${text}`);
        }
        const resp =  await response.json();
        if (resp.filename === docId) {
            const originalName = sessionStorage.getItem('fileName');
            if (originalName) {
                resp.filename = originalName;
            }
        }
        return resp; // Esperamos un objeto { filename, filecontent, allOk }
    } catch (error) {
        throw error;
    }
}
